module.exports = __webpack_public_path__ + "img/支付成功 (1).615f01a7.png";